import { render, staticRenderFns } from "./OffersPageContainer.vue?vue&type=template&id=2a758daa&scoped=true&"
import script from "./OffersPageContainer.vue?vue&type=script&lang=js&"
export * from "./OffersPageContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a758daa",
  null
  
)

export default component.exports